//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const IgnorePaymentAmountMismatch: FeatureFlag = {"Id":"IgnorePaymentAmountMismatch","Label":"[10.20]Ignore payment amount mismatch on submit","Impact":"Allows paid submissions with amount mismatches to proceed. When combined with ForceValidIfPaymentValid, invalid submissions can still advance while creating reviewer-visible payment mismatch issues.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
